<!--
 - Author : wanghongling.
 - Date   : 2021/1/5.
 - File   : mapItem.各区域地图（目前就福州和宁德）
 -->

<template>
  <div class="dining-map">
    <transition name="slide-right-fade">
      <!--食堂点位地图-->
      <div>
        <div class="dining-point"
             v-for="item in diningList"
             :key="item.cityId"
             :style="{
             top: item.position.top || 0,
             left: item.position.left || 0,
             zIndex: item.position.zIndex || 12,
           }"
             @click="$emit('changeProvince', item.cityId)">
          <div class="dining-point-item"
               v-for="dining in item.diningList"
               :key="dining.departmentId"
               :style="{
                   top: dining.position.top || 0,
                   left: dining.position.left || 0,
                   zIndex:13
                 }"
               @click="$emit('change', 'Shitang', dining.departmentId, dining.departmentName, dining.exceptionCount)">
            <div class="school-text active" :title="dining.departmentName">{{ dining.departmentName.substring(0, 4) }}</div>
            <div class="pos-img">
              <img src="./images/pos.png" alt="">
            </div>
            <span class="river-list-trg-shadow1"></span>
            <span class="river-list-trg-shine1"></span>
            <span class="river-list-trg-shine2"></span>
          </div>
          <img class="hide-class" :src="item.background" alt="">
        </div>

      </div>
    </transition>
    <transition name="slide-left1-fade">
      <!--中国视频背景-->
      <video class="video" :src="videoSrc" muted autoplay loop></video>
    </transition>
  </div>
</template>

<script>
import DININGPOINT from '../../../static/mapPoint/diningPoint'
import mapVideos from '../../../static/mapVideos'

export default {
  name: 'diningMap',
  data() {
    return {
      videoSrc: mapVideos[this.cityId]
    }
  },
  props: {
    list: {
      type: Array,
      default: () => []
    },
    cityId: {
      type: String,
      default: ''
    }
  },
  computed: {
    diningList() {
      console.log('diningList:', this.list, DININGPOINT) // eslint-disable-line
      let tmp = []
      this.list.forEach(value => {
        if (DININGPOINT[value.districtId]) { // eslint-disable-line
          const tmpDining = []
          const tmpArr = JSON.parse(JSON.stringify(DININGPOINT[value.districtId])) // eslint-disable-line
          tmpArr.diningList.forEach(diningStatic => {
            value.diningList.forEach(dining => {
              if (dining.departmentId === diningStatic.departmentId) {
                diningStatic.departmentName = dining.departmentName
                tmpDining.push(diningStatic)
              }
            })
          })
          tmpArr.diningList = tmpDining
          tmp.push({...value, ...tmpArr})
          console.log('tmpDining', tmpDining)
        }
      })
      console.log('tmp', tmp, this.cityId)
      return tmp
    }
  },
  methods: {
  }
}
</script>

<style lang="less" scoped>
.dining-map {

  .dining-point {
    position: absolute;
    //z-index: 12;
    cursor: pointer;
  }

  .dining-point-item {
    position: absolute;
    width: 112px;
    height: 50px;
    text-align: center;
    color: #fff;
    cursor: pointer;
    z-index: 999;

    .school-text {
      animation: trianglePop 1.5s infinite;
      padding-top: 18px;
      padding-bottom: 10px;
      font-size: 14px;
      background: url("./images/default.png") 50% 0 no-repeat;

      &.active {
        background-image: url("./images/default-check.png");
      }
    }

    .pos-img {
      animation: trianglePop 1.5s infinite;
      z-index: 999;
      position: absolute;
      left: 45px;
    }
  }

  .hide-class {
    animation: showHide 1s linear alternate infinite;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mapIndex/diningMap.vue